import React from "react";

function InputSelect({
  name,
  className,
  label,
  onChange,
  value,
  required,
  isDisable,
  errors,
  errormessage,
  option,
}: any) {
  return (
    <div className="space-y-1.5">
      {label && (
        <label className={`block text-sm font-medium text-slate-700 dark:text-slate-300 ${className || ""}`}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        id="dropdown"
        onChange={onChange}
        value={value}
        required={required ?? false}
        className={`w-full px-4 py-2.5 rounded-xl border text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 appearance-none cursor-pointer ${
          errors
            ? "border-red-400 bg-red-50 dark:bg-red-900/30 dark:border-red-500"
            : "border-slate-200 dark:border-slate-600 hover:border-slate-300 dark:hover:border-slate-500 bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200"
        } ${isDisable ? "bg-slate-100 dark:bg-slate-600 text-slate-400 dark:text-slate-500 cursor-not-allowed" : ""}`}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236366f1'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 12px center",
          backgroundSize: "16px",
          paddingRight: "40px",
        }}
        disabled={isDisable}
        name={name}
      >
        <option value="">Select an option</option>
        {option?.map((item: any, index: number) => (
          <option key={index} value={item?.value}>
            {item?.name}
          </option>
        ))}
      </select>
      {errors && (
        <p className="text-xs text-red-500 dark:text-red-400 mt-1">
          {errormessage
            ? errormessage
            : `${label ? label : "This field"} is mandatory`}
        </p>
      )}
    </div>
  );
}

export default InputSelect;
